/* One main photo with four thumbnail choices, matching the custom PDP gallery. */
(() => {
  function init(root = document) {
    root.querySelectorAll('[data-mosaic-gallery]').forEach(mosaic => {
      if (mosaic.showMedia) return;
      const items = Array.from(mosaic.children);
      const wrapper = mosaic.parentElement;
      const previous = wrapper.querySelector('[data-mosaic-prev]');
      const next = wrapper.querySelector('[data-mosaic-next]');
      const status = wrapper.querySelector('[data-mosaic-status]');
      const thumbnails = wrapper.querySelector('[data-mosaic-thumbnails]');
      let selected = 0;
      let thumbnailPage = -1;
      function show(index) {
        selected = Math.max(0, Math.min(items.length - 1, index));
        items.forEach((item, i) => {
          item.hidden = i !== selected;
          if (item.hidden) item.querySelectorAll('video').forEach(video => video.pause());
        });
        if (previous) previous.disabled = selected === 0;
        if (next) next.disabled = selected === items.length - 1;
        if (status) status.textContent = `${selected + 1} / ${items.length}`;
        const group = Math.floor(selected / 4);
        if (thumbnails && group !== thumbnailPage) {
          thumbnailPage = group;
          const focusedThumbnail = thumbnails.contains(document.activeElement);
          thumbnails.replaceChildren();
          items.slice(group * 4, group * 4 + 4).forEach((item, i) => {
            const position = group * 4 + i;
            const button = document.createElement('button');
            button.type = 'button';
            button.dataset.index = position;
            button.setAttribute('aria-label', (mosaic.dataset.thumbnailLabel || '__INDEX__').replace('__INDEX__', position + 1));
            const image = document.createElement('img');
            image.src = item.dataset.thumbnail || item.querySelector('img')?.src || '';
            image.alt = '';
            image.width = image.height = 160;
            button.append(image);
            button.addEventListener('click', () => show(position));
            thumbnails.append(button);
          });
          if (focusedThumbnail) thumbnails.querySelector('button')?.focus({preventScroll: true});
        }
        thumbnails?.querySelectorAll('button').forEach(button => button.setAttribute('aria-current', String(Number(button.dataset.index) === selected)));
      }
      mosaic.showMedia = id => {
        const index = items.findIndex(item => item.dataset.mediaId === String(id));
        if (index >= 0) show(index);
      };
      previous?.addEventListener('click', () => show(selected - 1));
      next?.addEventListener('click', () => show(selected + 1));
      show(0);
      if (mosaic.dataset.initialMediaId) mosaic.showMedia(mosaic.dataset.initialMediaId);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
